import { configureStore } from "@reduxjs/toolkit";

import changeSlice from "./Redux/changeSlice";
import filterSlice from "./Redux/filterSlice";
import cartSlice from "./Redux/cartSlice";
import authSlice from "./Redux/authSlice"

const rootReducer = {
  changeSlice,
  filterSlice,
  cartSlice,
  authSlice
};

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV!== 'production',
});

export default store;